import walletPaymentTypes from './types';

export const initialStates = {
	transactionId: null,
	amount: null,
	status: false,
	error: null,
	transactionList: {
		total_entries: null,
		data: null,
	},
};

const walletPaymentReducers = (state = initialStates, action) => {
	switch (action.type) {
		case walletPaymentTypes.NEW_TRANSACTION.SUCCESS: {
			return {
				...state,
				transactionId: action?.payload?.id,
				amount: action?.payload?.amount,
			};
		}
		case walletPaymentTypes.CHECK_BARCODE.SUCCESS:
			return {
				...state,
				status: true,
				error: null,
			};
		case walletPaymentTypes.INSUFFICIENT_BALANCE:
			return {
				...state,
				status: false,
				error: action.payload,
			};
		case walletPaymentTypes.GENERAL_ERROR:
			return {
				...state,
				status: false,
				error: action.payload,
			};
		case walletPaymentTypes.WALLET_TRANSACTION.SUCCESS:
			return {
				...state,
				transactionList: {
					total_entries: action?.payload?.total_entries,
					data: [
						...(state.transactionList?.data || []),
						...action?.payload?.data,
					],
				},
			};
		case walletPaymentTypes.WALLET_TRANSACTION.CLEAR:
			return {
				...state,
				transactionList: {
					total_entries: null,
					data: [],
				},
			};
		case walletPaymentTypes.CHECK_BARCODE.CLEAR:
			return {
				...state,
				status: null,
				error: null,
			};
		case walletPaymentTypes.CLEAR_AMOUNT:
			return {
				...state,
				amount: null,
			};
		default:
			return state;
	}
};

export default walletPaymentReducers;
